export default __webpack_public_path__ + "static/media/01.72ad2848.jpg";